class GiftProductCard {
  constructor(sectionId) {
    this.sectionId = sectionId;
    this.sectionContainer = document.querySelector(`#GiftSection-${sectionId}`);
    if (!this.sectionContainer) return;
    
    this.requiredCarousel = this.sectionContainer.querySelector('.gift-module--required scroll-carousel');
    this.requiredWrappers = this.sectionContainer.querySelectorAll('.gift-card-wrapper--required');
    this.optionalWrappers = this.sectionContainer.querySelectorAll('.gift-list-item--optional');
    this.addToCartBtn = this.sectionContainer.querySelector('[data-gift-add-to-cart]');
    
    this.init();
  }
  
  init() {
   
    if (this.requiredWrappers.length > 0) {
      let alreadySelected = false;
      this.requiredWrappers.forEach((wrapper, index) => {
        const isSelected = wrapper.getAttribute('aria-selected') === 'true';
        if (isSelected && !alreadySelected) {
          alreadySelected = true;
        } else if (isSelected && alreadySelected) {
          wrapper.setAttribute('aria-selected', 'false');
        }
      });
      
     
      if (!alreadySelected) {
        this.requiredWrappers[0].setAttribute('aria-selected', 'true');
      }
    }

    this.updateSelectedCount();
    this.bindEvents();
  }

  bindEvents() {
   
    this.requiredWrappers.forEach((wrapper, index) => {
      wrapper.addEventListener('click', () => {
        this.requiredWrappers.forEach(w => w.setAttribute('aria-selected', 'false'));
        wrapper.setAttribute('aria-selected', 'true');
        
       
        if (this.requiredCarousel && this.requiredCarousel.select) {
         
          const slide = wrapper.closest('.gift-carousel-slide');
          if (slide) {
            const slideIndex = Array.from(slide.parentElement.children).indexOf(slide);
            this.requiredCarousel.select(slideIndex);
          }
        }
        
        this.updateSelectedCount();
      });
    });

   
    this.optionalWrappers.forEach(wrapper => {
      wrapper.addEventListener('click', () => {
        const isSelected = wrapper.getAttribute('aria-selected') === 'true';
       
       
       
        
        if (isSelected) {
          wrapper.setAttribute('aria-selected', 'false');
        } else {
          this.optionalWrappers.forEach(w => w.setAttribute('aria-selected', 'false'));
          wrapper.setAttribute('aria-selected', 'true');
        }
        this.updateSelectedCount();
      });
    });

   
   
   
    if (this.requiredCarousel) {
      this.requiredCarousel.addEventListener('carousel:change', (event) => {
        const slideIndex = event.detail.index;
        const slides = this.requiredCarousel.querySelectorAll('.bundle-carousel-slide');
        if (slides[slideIndex]) {
          const firstInSlide = slides[slideIndex].querySelector('.gift-card-wrapper--required');
          if (firstInSlide && firstInSlide.getAttribute('aria-selected') !== 'true') {
            this.requiredWrappers.forEach(w => w.setAttribute('aria-selected', 'false'));
            firstInSlide.setAttribute('aria-selected', 'true');
            this.updateSelectedCount();
          }
        }
      });
    }

    if (this.addToCartBtn) {
      this.addToCartBtn.addEventListener('click', () => this.handleAddToCart());
    }
  }
  
  updateSelectedCount() {
    const selectedRequired = this.sectionContainer.querySelectorAll('.gift-card-wrapper--required[aria-selected="true"]').length;
    const selectedOptional = this.sectionContainer.querySelectorAll('.gift-list-item--optional[aria-selected="true"]').length;
    
   
    const totalCount = selectedRequired + selectedOptional;
    
    if (this.addToCartBtn) {
      const buttonText = this.addToCartBtn.querySelector('.loader-button__text');
      if (buttonText) {
        const baseText = buttonText.getAttribute('data-base-text') || 'Add Bundle to Cart';
        const itemsText = buttonText.getAttribute('data-items') || 'items';
        buttonText.textContent = `${baseText} (${totalCount} ${itemsText})`;
      }
    }
  }
  
  getCardData(wrapper) {
    if (!wrapper) return null;
    
   
    const variantDropdown = wrapper.querySelector('[data-gift-variant-dropdown]');
    if (variantDropdown && variantDropdown.selectedIndex >= 0) {
      const selectedOption = variantDropdown.options[variantDropdown.selectedIndex];
      return {
        variantId: selectedOption.value,
        price: parseInt(selectedOption.getAttribute('data-variant-price')) || 0
      };
    }

   
    if (wrapper.dataset.defaultVariantId) {
      return {
        variantId: wrapper.dataset.defaultVariantId,
        price: parseInt(wrapper.dataset.defaultVariantPrice) || 0
      };
    }
    
    return null;
  }
  
  async handleAddToCart() {
    const items = [];
    
   
    this.requiredWrappers.forEach(wrapper => {
      if (wrapper.getAttribute('aria-selected') === 'true') {
        const data = this.getCardData(wrapper);
        if (data && data.variantId) {
          items.push({ id: data.variantId, quantity: 1 });
        }
      }
    });
    
    if (items.length === 0) {
      alert('Please select a required product from Step 1');
      return;
    }

   
    this.optionalWrappers.forEach(wrapper => {
      if (wrapper.getAttribute('aria-selected') === 'true') {
        const data = this.getCardData(wrapper);
        if (data && data.variantId) {
          items.push({ id: data.variantId, quantity: 1 });
        }
      }
    });

    this.addToCartBtn.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });
      
      let responseData;
      try {
        responseData = await response.json();
      } catch (jsonError) {
        const text = await response.text();
        console.error('Failed to parse JSON response:', text);
        responseData = { message: `Invalid response from server (HTTP ${response.status})` };
      }
      if (!response.ok) {
        throw new Error(responseData.message || responseData.description || 'Failed to add items to cart');
      }
      
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.documentElement.dispatchEvent(new CustomEvent('cart-drawer:open', { bubbles: true }));
      
    } catch (e) {
      alert(e.message || 'Error adding to cart. Please try again.');
    } finally {
      this.addToCartBtn.setAttribute('aria-busy', 'false');
    }
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const giftSections = document.querySelectorAll('[id^="GiftSection-"]');
  giftSections.forEach(section => {
    const sectionId = section.id.replace('GiftSection-', '');
    new GiftProductCard(sectionId);
  });
});